import {Api} from "./Api";
import { apiUrl } from "../enviroments/enviroments.dev";
import { UserOrganization } from "../models/UserOrganization";
import { OrganizationStart, OrgUsers, Profit } from "../models/Organization";

const target = "/organizations";

export class OrganizarionService {

    public static getAllOrganizations() {
        return Api.get(apiUrl(target));
    }

    public static getCompaniesOverview() : Promise<Array<any>> {
        return Api.get(apiUrl(target+"/overview/companies"));
    }

    public static createOrganization (organizationName:string) {
        return Api.post(apiUrl(target), {organizationName});
    }

    public static editOrganization ( payload :any) {
        return Api.patch(apiUrl(target+"/"+payload.id), payload);
    }

    public static getOrganizationAccounts (orgs: any) : Promise<Array<any>>{
        let ids = '';
        for (let i=0; i < orgs.length; i++) {
            if (i !== 0) ids +=';'
            ids += orgs[i].organization.id
        } 
        return Api.get(apiUrl(target+"/accounts/"+ids));
    }

    public static getAll (orgId: number) : Promise<OrganizationStart> {
        return Api.get(apiUrl(target+"/getAll/"+orgId));
    }

    public static getOrganizationProfit (orgId: number, month?:boolean) : Promise<Profit[]> {
        return Api.get(apiUrl(target+"/profit/"+orgId+"/"+String(month)));
    }

    public static getUsersFromOrganization (orgId: number) : Promise<OrgUsers[]> {
        return Api.get(apiUrl(target+"/users/"+orgId));
    }

}